import React from "react";

import { CheckCircleIcon } from "@heroicons/react/solid";

import Heading from "components/heading";

import HeroSection from "../../hero-section";

const title = "Data Has Never Been More Important in Solar";

const listItems = [
  { title: "25D Sunset", description: "Traditional sales methods used with increased urgency." },
  { title: "48E", description: "Leases & PPAs gain market share. Loan products morph." },
  { title: "Data", description: "Predictability & sound metrics become more critical than ever." },
  { title: "Cross-Selling", description: "Installers adding additional products to increase per-job revenue." },
];

const ImportantData = () => (
  <div className="bg-navy text-white py-10">
    <HeroSection title={title}>
      <div className="grow flex flex-col items-center">
        <HeroSection.Content className="w-full md:text-center mb-16">
          <HeroSection.Header>
            <Heading tag="h2">{title}</Heading>
          </HeroSection.Header>
          <HeroSection.Description className="text-gray-300">
            The solar industry is evolving fast. Policy changes, market uncertainty, and tighter margins mean one thing:
            you need better data to stay ahead. Considering where residential solar is headed, data and BI will play a
            critical role for companies looking to last. No other platform offers reporting this robust, this
            integrated, and this easy to use. It’s an industry first.
          </HeroSection.Description>
        </HeroSection.Content>
        <HeroSection.Content className="w-full grid grid-cols-1 xs:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-8">
          {listItems.map(item => (
            <div key={item.title} className="space-y-2 text-center max-w-xs mx-auto">
              <CheckCircleIcon className="text-primary h-12 w-12 mx-auto" />
              <strong className="block text-primary">{item.title}</strong>
              <p className="text-gray-300">{item.description}</p>
            </div>
          ))}
        </HeroSection.Content>
      </div>
    </HeroSection>
  </div>
);

export default ImportantData;
